import {createContext} from 'react';

export const PendingTransaction = createContext(false);